module.exports = "/_next/static/images/e819b9ff9d36b59dfe147cfa2c9f4bc4-people.svg.webp";